"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientApiErrorRegistry = void 0;
/**
 * Per-endpoint error registry — which `PatientErrorCodes` (plus the
 * generic cross-cutting codes every endpoint can return: validation,
 * not-found-by-id-for-a-different-reason, etc.) a specific endpoint
 * can actually respond with. This is what an OpenAPI operation's
 * `responses` map is built from (`../openapi`), and what
 * `docs/PATIENT-API-ERROR-GUIDE.md` documents per endpoint.
 */
const patient_error_codes_1 = require("./patient-error-codes");
const patient_error_codes_2 = require("./patient-error-codes");
const GENERIC_CODES = [patient_error_codes_1.PatientErrorCodes.VALIDATION_ERROR];
function toContract(code) {
    return { code, ...(0, patient_error_codes_2.getPatientErrorCatalogEntry)(code) };
}
function endpoint(name, codes) {
    return { endpoint: name, errors: [...codes, ...GENERIC_CODES].map(toContract) };
}
exports.PatientApiErrorRegistry = {
    registerPatient: endpoint('registerPatient', [patient_error_codes_1.PatientErrorCodes.PATIENT_CONTACT_METHOD_REQUIRED]),
    registerEmergency: endpoint('registerEmergency', []),
    registerUnknown: endpoint('registerUnknown', []),
    registerNewborn: endpoint('registerNewborn', [patient_error_codes_1.PatientErrorCodes.PATIENT_NOT_FOUND]),
    registerCorporate: endpoint('registerCorporate', [patient_error_codes_1.PatientErrorCodes.PATIENT_CONTACT_METHOD_REQUIRED]),
    registerReferral: endpoint('registerReferral', [patient_error_codes_1.PatientErrorCodes.PATIENT_CONTACT_METHOD_REQUIRED]),
    updateDemographics: endpoint('updateDemographics', [patient_error_codes_1.PatientErrorCodes.PATIENT_NOT_FOUND]),
    updateCoverage: endpoint('updateCoverage', [
        patient_error_codes_1.PatientErrorCodes.COVERAGE_NOT_FOUND,
        patient_error_codes_1.PatientErrorCodes.COVERAGE_CLOSED_RECORD,
    ]),
    grantConsent: endpoint('grantConsent', [
        patient_error_codes_1.PatientErrorCodes.CONSENT_GUARDIAN_INVALID,
    ]),
    withdrawConsent: endpoint('withdrawConsent', [
        patient_error_codes_1.PatientErrorCodes.CONSENT_NOT_FOUND,
        patient_error_codes_1.PatientErrorCodes.CONSENT_NOT_ACTIVE,
    ]),
    mergePatient: endpoint('mergePatient', [
        patient_error_codes_1.PatientErrorCodes.PATIENT_NOT_FOUND,
        patient_error_codes_1.PatientErrorCodes.PATIENT_ALREADY_MERGED,
        patient_error_codes_1.PatientErrorCodes.MERGE_SELF_MERGE_NOT_ALLOWED,
        patient_error_codes_1.PatientErrorCodes.MERGE_RESTRICTED_BY_PROTECTION,
    ]),
    rollbackMerge: endpoint('rollbackMerge', [
        patient_error_codes_1.PatientErrorCodes.MERGE_SESSION_NOT_FOUND,
        patient_error_codes_1.PatientErrorCodes.MERGE_ROLLBACK_INVALID_STATE,
    ]),
    searchPatient: endpoint('searchPatient', []),
    advancedSearch: endpoint('advancedSearch', []),
    timeline: endpoint('timeline', [patient_error_codes_1.PatientErrorCodes.PATIENT_NOT_FOUND]),
    applyRecordProtection: endpoint('applyRecordProtection', [patient_error_codes_1.PatientErrorCodes.PROTECTION_ALREADY_ACTIVE]),
    releaseRecordProtection: endpoint('releaseRecordProtection', [
        patient_error_codes_1.PatientErrorCodes.PROTECTION_NOT_FOUND,
        patient_error_codes_1.PatientErrorCodes.PROTECTION_INVALID_STATE,
    ]),
    removeRecordProtection: endpoint('removeRecordProtection', [
        patient_error_codes_1.PatientErrorCodes.PROTECTION_NOT_FOUND,
        patient_error_codes_1.PatientErrorCodes.PROTECTION_INVALID_STATE,
    ]),
    resolveIdentity: endpoint('resolveIdentity', [
        patient_error_codes_1.PatientErrorCodes.IDENTITY_SELF_COMPARISON_NOT_ALLOWED,
        patient_error_codes_1.PatientErrorCodes.PATIENT_NOT_FOUND,
    ]),
    reviewIdentity: endpoint('reviewIdentity', [
        patient_error_codes_1.PatientErrorCodes.IDENTITY_CANDIDATE_NOT_FOUND,
        patient_error_codes_1.PatientErrorCodes.IDENTITY_CANDIDATE_ALREADY_REVIEWED,
    ]),
};
//# sourceMappingURL=patient-error-registry.js.map